import { differenceWith, get } from 'lodash-es';

import Fuse from 'fuse.js';

const removeAccents = (str) => str.normalize('NFD').replace(/[\u0300-\u036F]/g, '');

const findBy = (name, list, keys) => {
  const options = {
    keys,
    shouldSort: true,
    includeMatches: true,
    distance: 1000,
    minMatchCharLength: name.length,
    getFn: (obj, path) => {
      // Use the default `get` function
      const value = Fuse.config.getFn(obj, path);
      // ... do something with `value`
      return removeAccents(value);
    },
  };
  const fuse = new Fuse(list, options);
  const results = fuse.search(name);
  return results.slice(0, 30);
};

const filterSecondaryActivities = (params) => {
  if (params.length === 4) {
    const [secondaryActivityList, term, secondarySelected, mainSelected] = params;
    if (term === '' || term === null) {
      return [];
    }
    const fuse = () => {
      const options = {
        keys: ['name'],
        shouldSort: true,
        includeMatches: true,
        distance: 1000,
        minMatchCharLength: term.length,
        getFn: (obj, path) => {
          // Use the default `get` function
          const value = Fuse.config.getFn(obj, path);
          // ... do something with `value`
          return removeAccents(value);
        },
      };
      return new Fuse(secondaryActivityList, options);
    };
    return differenceWith(
      fuse().search(term).map((result) => result.item),
      [...new Array(secondarySelected), mainSelected],
      (a, b) => a.id === b.id,
    );
  }
  return [];
};

const spanify = (text, cssClass = false) => `<span ${cssClass
  ? `class="${cssClass}"` : ''}>${text}</span>`;

const hightlightBuilder = (researchedActivity, keyName) => {
  const name = get(researchedActivity.item, keyName);
  const htmlString = [];
  const add = (substring) => { htmlString.push(spanify(substring)) };
  const highlight = (substring) => {
    htmlString.push('<span class="text-primary font-weight-bold">');
    add(substring);
    htmlString.push('</span>');
  };

  const nameFormated = [...researchedActivity.matches]
    .filter(({ key }) => key === keyName)
    .map(({ indices }) => {
      add('<span>');
      let lastIndice = 0;
      for (let i = 0; i < indices.length; i += 1) {
        const [startIndice, endIndice] = indices[i];
        if (startIndice !== 0) {
          add(name.substring(lastIndice, startIndice));
        }
        highlight(name.substring(startIndice, endIndice + 1));
        lastIndice = endIndice + 1;
      }
      add(name.substring(lastIndice));
      add('</span>');
      return htmlString.join('');
    });
  return nameFormated.length > 0 ? nameFormated : spanify(name);
};

const breadcrumb = (researchedActivity) => `${hightlightBuilder(researchedActivity, 'name')}`;

export {
  breadcrumb,
  filterSecondaryActivities,
  findBy,
};
